export const environment = {
    production: true,
    AUTH_URL: 'https://auth.simadvisory.com/auth',
    CLIENT: "PROD_SPRICED_CDBU_Client",
    REALMS: "PROD_SPRICED_NRP",
    URL: 'https://excelplugin.spriced.cdbu.simadvisory.com',
}
